import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, TextField, TextareaAutosize } from '@mui/material';
import "./departments.scss"
import "../../../scss/common.scss"

const DepartmentDialogBox = (props: any) => {
    const { showAddModal, setShowAddModal } = props;
    return (
        <>
            <Dialog
                open={showAddModal}
                onClose={() => setShowAddModal(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" className='Department-background fw-600 ' sx={{ fontSize: "16px", mb: 3 }}>
                    Department
                </DialogTitle>
                <DialogContent className='content'>
                    <DialogContentText id="alert-dialog-description">
                        <Grid container>
                            <Grid item md={12} xs={12} display='flex' flexDirection='column'>
                                <label>Department Name</label>
                                <TextField
                                    size="small"
                                    value=""
                                    // name="name"
                                    // onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Name"
                                    sx={{
                                        mb: "20px", '& label.Mui-focused': {
                                            color: '#F78812',
                                        },
                                        '& .MuiInput-underline:after': {
                                            borderBottomColor: '#F78812',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#CCCCCC',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#F78812',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#F78812',
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item md={12} xs={12} display='flex' flexDirection='column'>
                                <label className='text-color fw-500 fs-14'>Description</label>
                                <TextareaAutosize minRows={3} className='input' placeholder='Write somthing' style={{
                                    borderRadius: "4px", paddingTop: '10px', fontSize: '16px', paddingLeft: '15px', marginBottom: "20px",
                                }} />
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid item md={12} xs={6}>
                        <button className='btn cancel text-color btn-light-grey' onClick={() => setShowAddModal(false)}>Cancel</button>
                        <button className='btn cancel save btn-secondary' onClick={() => setShowAddModal(false)}>Save</button>
                    </Grid>
                </DialogActions>
            </Dialog>

        </>
    )
}
export default DepartmentDialogBox